/** Distance en kilomètres entre deux coordonnées (formule de haversine). */
export function distanceKm(from: [number, number], to: [number, number]): number {
  const earthRadius = 6371
  const toRad = (value: number) => (value * Math.PI) / 180
  const dLat = toRad(to[0] - from[0])
  const dLng = toRad(to[1] - from[1])
  const a =
    Math.sin(dLat / 2) ** 2 + Math.cos(toRad(from[0])) * Math.cos(toRad(to[0])) * Math.sin(dLng / 2) ** 2
  return 2 * earthRadius * Math.asin(Math.sqrt(a))
}

/** Longueur cumulée d'un trajet en kilomètres. */
export function routeLengthKm(points: [number, number][]): number {
  return points.reduce((total, point, index) => (index === 0 ? 0 : total + distanceKm(points[index - 1], point)), 0)
}
